<template>
  <div style="display: flex">
    <div style="font-weight: bold; font-size: 20px">
      <v-icon class="mr-3">mdi-monitor-cellphone</v-icon>
      Client Settings
    </div>
    <v-spacer />
  </div>
  <v-divider class="mt-3" />
  <div class="config-page-body">
    <v-card
      flat
      style="margin-top: 40px; margin-bottom: 20px"
      class="pa-6">
      <v-card-subtitle style="text-align: center">
        Appearance
      </v-card-subtitle>
      <v-divider class="mt-3 mb-4" />
      <div class="setting-row">
        <div class="setting-label">
          <v-icon class="mr-2">mdi-theme-light-dark</v-icon>
          Theme
        </div>
        <div class="setting-description">
          Override the color theme for this browser. Auto follows your system preference.
        </div>
        <v-btn-toggle
          v-model="themePreference"
          mandatory
          class="mt-3"
          density="comfortable"
          rounded="lg"
          color="primary">
          <v-btn value="auto">
            <v-icon start>mdi-brightness-auto</v-icon>
            Auto
          </v-btn>
          <v-btn value="dark">
            <v-icon start>mdi-weather-night</v-icon>
            Dark
          </v-btn>
          <v-btn value="light">
            <v-icon start>mdi-weather-sunny</v-icon>
            Light
          </v-btn>
        </v-btn-toggle>
      </div>
    </v-card>
    <v-alert
      type="info"
      variant="tonal"
      density="compact"
      class="mt-4">
      Client settings are stored locally in your browser and only affect this device.
    </v-alert>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import { state } from '@/stores/deluge.js';

const themePreference = ref('auto');

onMounted(() => {
  // Load saved preference from localStorage
  const saved = localStorage.getItem('themePreference');
  if (saved && ['auto', 'dark', 'light'].includes(saved)) {
    themePreference.value = saved;
  }
});

watch(themePreference, (newVal) => {
  // Save to localStorage
  localStorage.setItem('themePreference', newVal);

  // Apply the theme based on preference
  applyTheme(newVal);
});

function applyTheme(preference) {
  let theme;

  if (preference === 'auto') {
    // Use system preference
    const systemDark =
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: dark)').matches;
    theme = systemDark ? 'dark' : 'light';
  } else {
    theme = preference;
  }

  // Update localStorage and state
  localStorage.setItem('theme', theme);
  state.theme = theme;
  document.documentElement.setAttribute('data-theme', theme);
}
</script>

<style scoped>
@import './config.css';

.setting-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.setting-label {
  font-weight: 500;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.setting-description {
  font-size: 13px;
  opacity: 0.7;
}
</style>
